import {IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import {PropsWithChildren} from "react";
import {Popover} from "../../../misc/Popover";

export function TaskPopover(props: PropsWithChildren<{
    title: string;
    extra?: any;
    anchorEl: any;
    onClose(): void;
}>) {
    return (
        <Popover open anchorEl={props.anchorEl} onClose={() => props.onClose()}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: 4,
                alignItems: "center",
            }}>
                <div style={{flex: 1, padding: 4, paddingLeft: 8, fontWeight: "600"}}>
                    {props.title}
                </div>

                {props.extra}
                <IconButton size="small" onClick={() => props.onClose()}>
                    <Close />
                </IconButton>
            </div>

            <div style={{
                flex: 1,
                overflowY: "auto",
                maxHeight: window.innerHeight - 400,
            }}>
                {props.children}
            </div>
        </Popover>
    )
}